import { createContext, PropsWithChildren, useState } from 'react'
import { MenuItem } from 'primereact/menuitem'

import { useProvideContext } from '../../hooks/context'
import t from '../../tools/t'
import { pi } from '../common/pure/PrimeIcon'

export interface ArchiveContextValue {
    includeArchived: boolean
    hideArchived: () => void
    showArchived: () => void
    toggleArchived: () => void

    toggleArchiveMenuItem: MenuItem
}

const ArchiveContext = createContext<ArchiveContextValue | undefined>(undefined)

export default function ({ children }: PropsWithChildren) {
    const [includeArchived, setIncludeArchived] = useState(false)

    const showArchived = () => setIncludeArchived(true)

    const hideArchived = () => setIncludeArchived(false)

    const toggleArchived = () => setIncludeArchived((current) => !current)

    const toggleArchiveMenuItem = {
        label: includeArchived ? t('common_hide_archived') : t('common_show_archived'),
        icon: includeArchived ? pi('file-excel') : pi('file-o'),
        command: toggleArchived,
    }

    const value: ArchiveContextValue = {
        includeArchived,
        hideArchived,
        showArchived,
        toggleArchived,
        toggleArchiveMenuItem,
    }

    return <ArchiveContext.Provider value={value}>{children}</ArchiveContext.Provider>
}

export const useArchiveContext = () => useProvideContext(ArchiveContext, 'Archive')
